var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.103,
    height: 5.161,
    viewBox: "0 0 10.103 5.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_7787532_next_arrow_direction_down_left_icon",
    "data-name": "7787532_next_arrow_direction_down_left_icon",
    d: "M4.625,6.378,1.089,9.915a.605.605,0,0,1-.876,0,.605.605,0,0,1,0-.876L3.749,5.5a.605.605,0,0,0,0-.876L.181,1.058A.62.62,0,1,1,1.058.181L4.594,3.718A1.88,1.88,0,0,1,4.625,6.378Z",
    transform: "translate(0 5.161) rotate(-90)",
    fill: "#4c96ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue);
export default __webpack_public_path__ + "static/media/arrow-blue.6ce31a2072932642c84c2b9d00d177e2.svg";
export { ForwardRef as ReactComponent };